export default __webpack_public_path__ + "static/media/email1.c0bba7b5.png";